import { render } from "./PreviousGamesLeaderboard.vue?vue&type=template&id=1304b6d3&scoped=true"
import script from "./PreviousGamesLeaderboard.vue?vue&type=script&lang=js"
export * from "./PreviousGamesLeaderboard.vue?vue&type=script&lang=js"

import "./PreviousGamesLeaderboard.vue?vue&type=style&index=0&id=1304b6d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1304b6d3"]])

export default __exports__